import React from 'react'

function Vision() {
  return (
    <div>Vision
    <br/><br/>
    <h1>thes is Vision page</h1>
    </div>
  )
}

export default Vision